import api from "./api";

export const getUserHubs = async (userId) => {
  const res = await api.get(`/hub/user/${userId}`);
  return res.data?.data?.$values ?? res.data?.data ?? [];
};

export const getHubById = async (hubId) => {
  const res = await api.get(`/hub/${hubId}`);
  return res.data?.data ?? null;
};

export const updateHub = async (hubId, fields) => {
  const formData = new FormData();

  // Required fields
  formData.append("Id", hubId);
  formData.append("UserId", fields.userId);
  formData.append("Name", fields.name);
  formData.append("Bio", fields.bio ?? "");
  formData.append("ShowAddress", fields.showAddress ?? false);

  // Address
  formData.append("AddressId", fields.addressId ?? "");
  formData.append("Address_DisplayName", fields.address_DisplayName ?? "");
  formData.append("Address_FullAddress", fields.address_FullAddress ?? "");
  formData.append("Address_City", fields.address_City ?? "");
  formData.append("Address_Province", fields.address_Province ?? "");
  formData.append("Address_PostalCode", fields.address_PostalCode ?? "");
  formData.append("Address_Latitude", fields.address_Latitude ?? 0);
  formData.append("Address_Longitude", fields.address_Longitude ?? 0);

  // Banking
  formData.append("BankAccount_Id", fields.bankAccount_Id ?? "");
  formData.append("BankAccount_HubId", hubId);
  formData.append("BankAccount_Name", fields.bankAccount_Name ?? "");
  formData.append("BankAccount_BankName", fields.bankAccount_BankName ?? "");
  formData.append("BankAccount_AccountNumber", fields.bankAccount_AccountNumber ?? "");
  formData.append("BankAccount_BranchCode", fields.bankAccount_BranchCode ?? "");

  // Image file (optional)
  if (fields.file) formData.append("file", fields.file);

  const res = await api.put(`/hub/${hubId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};